import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ showDropdown, setShowDropdown }) => {
  return (
    <header className="header landing">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="navigation">
              <nav className="navbar navbar-expand-lg navbar-light">
                <div className="brand-logo">
                  <a href="/">
                    <img src="images/gps.png" alt="" classN ame="logo-primary" />
                    <img src="images/gps.png" alt="" className="logo-white" />
                  </a>
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                  <ul className="navbar-nav">

                    <li className="nav-item">
                      <a className="nav-link" href="/" >
                        Home
                      </a>
                    </li>

                    <li
                      className={`nav-item dropdown ${showDropdown ? 'show' : ''}`}
                      onMouseEnter={() => setShowDropdown(true)}
                      onMouseLeave={() => setShowDropdown(false)}
                    >
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        onClick={e => e.preventDefault()}
                        aria-expanded={showDropdown ? 'true' : 'false'}
                      >
                        Our Services
                      </a>
                      <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`} style={{ display: showDropdown ? 'block' : '', visibility: showDropdown ? 'block' : '', opacity: showDropdown ? '1' : '0' }}
                      >
                        <Link className="dropdown-item" to="/MutualFundPage">Mutual Fund</Link>
                        <Link className="dropdown-item" to="/LoanAgainstSecuritiesPage">Loan Against Securities</Link>
                        <Link className="dropdown-item" to="/BondPage">Bond</Link>
                        <Link className="dropdown-item" to="/AIFPage">AIF</Link>
                        <Link className="dropdown-item" to="/ResearchAnalystPage">Research Analyst</Link>
                        <Link className="dropdown-item" to="/GlobalAccessPage">Global Access</Link>
                      </div>
                    </li>


                    <li className="nav-item">
                      <Link className="nav-link" to="/career">Career</Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/contact">Contact Us</Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/about">About Us</Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="https://bloggps.torbitmultisoft.in/">Blogs</Link>
                    </li>

                    <li className="nav-item">
                      <Link className="nav-link" to="/RetirementCalculator">Calculator</Link>
                    </li>

                    <div className="signin-btnsss">
                      <Link className="btn btn-primary" to="https://gpsfinvest.investwell.app/app/#/login">Login / Register</Link>
                    </div>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
